module.exports = __webpack_public_path__ + "static/media/Logo.b7845f83.png";